var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 36.5,
    r: 36.5,
    fill: "#DFDFDF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9588 28.8122C27.9588 24.1023 31.7906 20.2705 36.5005 20.2705C41.2104 20.2705 45.0422 24.1023 45.0422 28.8122C45.0422 33.522 41.2104 37.3538 36.5005 37.3538C31.7906 37.3538 27.9588 33.522 27.9588 28.8122ZM43.5337 39.1835C42.5787 38.941 41.5401 39.0777 40.6808 39.556C38.0876 40.9978 34.9134 40.9978 32.3202 39.556C31.4626 39.0794 30.4222 38.9444 29.4673 39.1835C26.0643 40.0428 23.688 43.1315 23.688 46.6934V48.4205C23.688 49.5104 23.9784 50.5762 24.5302 51.5056C24.9795 52.2606 25.8217 52.7305 26.7254 52.7305H46.2739C47.1776 52.7305 48.0197 52.2624 48.469 51.5039C49.0208 50.5763 49.3113 49.5104 49.3113 48.4205V46.6934C49.313 43.1315 46.9367 40.0428 43.5337 39.1835Z",
    fill: "#6C01A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleProfile);
export default __webpack_public_path__ + "static/media/circleProfile.8ee7371a.svg";
export { ForwardRef as ReactComponent };